import React from "react";
import { crashWs } from"../../../websocketController";
import Graph from "../Graph/Graph";
import { CRASH_STATUS_DISCONNECTED, CRASH_STATUS_LOADING } from "../CrashGame";


class Chart extends React.PureComponent {
  constructor(props) {
    super(props);

    this.graphContainer = null;
    this.canvasWidth = null;
    this.canvasHeight = null;

    this.chartRef = React.createRef();

    this.state = {
      gameState: {
        status: CRASH_STATUS_LOADING,
        elapsed: 0,
        next_round_at: null
      }
    };
  }

  componentDidMount() {
    this.mounted = true;

    crashWs.sub("crash", this.onDataReceived);
    this.initGraph();
    window.addEventListener("resize", this.resizeGraph);

    window.requestAnimationFrame(this.drawGraph);
  }

  componentWillUnmount() {
    crashWs.unsub("crash", this.onDataReceived);
    window.removeEventListener("resize", this.resizeGraph);
  }

  onDataReceived = (data) => {
    const type = data.type;
    if (type === "cf") this.onCfChanged(data);
  };

  onCfChanged = (response) => {
    const data = { ...response.payload, status: +response.payload.current };
    this.setState({ gameState: data });
  };

  initGraph = () => {
    this.graphContainer = document.getElementById("crash-chart");
    this.canvasWidth = this.graphContainer.offsetWidth - 30;
    this.canvasHeight = this.graphContainer.offsetHeight - 30;
    this.graph = new Graph(this.canvasWidth, this.canvasHeight);
  };

  resizeGraph = () => {
    this.canvasWidth = this.graphContainer.offsetWidth - 30;
    this.canvasHeight = this.graphContainer.offsetHeight - 30;
    this.graph.resize(this.canvasWidth, this.canvasHeight);
  };

  drawGraph = () => {
    if (this.mounted) {
      const canvas = this.chartRef.current;
      if (!canvas || !canvas.getContext) {
        console.log("No canvas");
        return;
      }

      canvas.width = this.canvasWidth * 2;
      canvas.height = this.canvasHeight * 2;
      canvas.getContext("2d").scale(2, 2);

      if (this.state.gameState.status !== CRASH_STATUS_LOADING && this.props.status !== CRASH_STATUS_DISCONNECTED) {
        this.graph.setData(canvas.getContext("2d"), canvas, this.state.gameState);
        this.graph.calculatePlotValues();
        this.graph.clean();
        this.graph.drawAxes();
        this.graph.drawGraph();
        this.graph.drawIndexes();
        this.graph.drawGameData();
      }

      window.requestAnimationFrame(this.drawGraph);
    }
  };

  render() {
    return (
      <canvas style={ { width: this.canvasWidth, height: this.canvasHeight } } ref={ this.chartRef }/>
    );
  }
}

export default Chart;


// WEBPACK FOOTER //
// ./app/components/CrashGame/Chart/Chart.jsx